import businessMenus from './menus.json'
import workMenu from './prodWorkMenu.json'
//import workMenu from './workMenu.json'
import sysMenu from './sysMenus.json'
import store, {types as storeTypes} from '../vuex'

let menus=[].concat(businessMenus,workMenu, sysMenu)
let slideMenus = [];

function linkParent(menus, parentMenu) {
    menus.forEach(menu => {
        menu.expanded = true
        menu.active = false
        menu.parent = parentMenu
        if(menu.children){
            linkParent(menu.children, menu)
        }
    })
}

function init() {
    linkParent(menus, null)
}

function findMenuItems(menus, path, items) {
    menus.forEach(menu => {
        menu.active = false
        if(menu.route === path){
            items.push(menu)
        }
        if(menu.children){
            findMenuItems(menu.children, path, items)
        }
    })
}


function routerChanged(to) {
    var activeItems = []
    findMenuItems(menus, to.fullPath, activeItems)

    var _slideMenus = [];
    activeItems.forEach(menu => {
        menu.expanded = menu.active = true
        var parent = menu.parent
        while(parent){
            parent.expanded = parent.active = true
            if(!parent.parent){
                parent.children && parent.children.forEach(child => {
                    _slideMenus.push(child)
                })
            }
            parent = parent.parent
        }
    })

    if(_slideMenus.length){
        slideMenus.splice(0, slideMenus.length)
        _slideMenus.forEach(item => {
            slideMenus.push(item)
        })
    }

    if(!slideMenus.length){
        store.commit(storeTypes.SHOW_SLIDEBAR, false)
    }

}

init();

export default {
    menus,
    routerChanged,
    slideMenus
}



// WEBPACK FOOTER //
// ./src/layout/menus.js